import {
  LOGIN, LOGOUT,
  REGISTER,
  LOGIN_PAGE_UNLOADED,
  REGISTER_PAGE_UNLOADED,
  ASYNC_START,
} from '../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case LOGOUT:
      return {};
    case LOGIN:
    case REGISTER:

      return {
        ...state,
        inProgress: false,
        errors: action.payload.error? action.payload.error.message:
        action.payload.status === 200 ? action.payload.data.user.is_password_expired ? action.payload.message : null : action.payload.message
        // errors: action?action.error ? action.payload.errors : null: null
      };
    case LOGIN_PAGE_UNLOADED:
    case REGISTER_PAGE_UNLOADED:
      return {};
    case ASYNC_START:
      if (action.subtype === LOGIN || action.subtype === REGISTER) {
        return { ...state, inProgress: true, errors: null };
      }
      break;
    default:
      return state;
  }

  return state;
};



// WEBPACK FOOTER //
// src/reducers/auth.js